import { type Modifier, TextLinks, } from "@quickpoint.me/shared";
import getIndicesOf from "./getIndexOf";
import replaceText, { type Replacement } from "./replaceText";

export default function replaceLinks(text: string, modifier: Modifier) {
    const linkIndexes = getIndicesOf(text, TextLinks.link);
    const endLinkIndexes = getIndicesOf(text, TextLinks.endLink);
    const links = modifier.links
    const instances: Replacement[] = [];
    linkIndexes.forEach((linkIndex, idx) => {
        // if the user hasn't create a link modifier for the link, don't replace it
        if (!links || !links[idx]) return;
        const start = linkIndex;
        const end = endLinkIndexes[idx];
        const link = text.slice(start + TextLinks.link.length, end);
        // const onClick = `//console.log("clicked ${idx}")`
        const html = `<a  data-testid="link-${idx}" data-link="${links[idx].link}" data-type="${links[idx].type}" target="_blank">${link}</a>`;
        instances.push({ start, end: end + TextLinks.endLink.length, replacement: html });
    });

    return replaceText(text, instances);
}